import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetActivePremiereEntitiesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetActivePremiereEntitiesQuery = { __typename?: 'Query', activeProject?: { __typename?: 'PremiereProject', id?: string | null, activeSequence?: { __typename?: 'PremiereSequence', id?: string | null, name?: string | null } | null } | null };


export const GetActivePremiereEntities = /*#__PURE__*/ gql`
    query GetActivePremiereEntities {
  activeProject {
    id
    activeSequence {
      id
      name
    }
  }
}
    ` as unknown as DocumentNode<GetActivePremiereEntitiesQuery, GetActivePremiereEntitiesQueryVariables>;

          

          export const useGetActivePremiereEntitiesQuery = (options?:QueryHookOptions<GetActivePremiereEntitiesQuery, GetActivePremiereEntitiesQueryVariables>) => useQuery(GetActivePremiereEntities, options);

          

          export type GetActivePremiereEntitiesQueryOptions = QueryHookOptions<GetActivePremiereEntitiesQuery, GetActivePremiereEntitiesQueryVariables>;

          

          export const useGetActivePremiereEntitiesLazyQuery = (options?:LazyQueryHookOptions<GetActivePremiereEntitiesQuery, GetActivePremiereEntitiesQueryVariables>) => useLazyQuery(GetActivePremiereEntities, options);

          

          export type GetActivePremiereEntitiesQueryResult = ReturnType<typeof useGetActivePremiereEntitiesQuery>;

          
